export const linkToClassement = '/classements'
